export const linkToClassement = '/classements'
